import n from "./index.es190.js";
import o from "./index.es191.js";
import e from "react";
const m = (g, r = 1) => ({
  ocre: () => `rgba(255, 209, 105, ${r})`,
  green: () => `rgba(47, 99, 65, ${r})`,
  violet: () => `rgba(95, 63, 107, ${r})`,
  tomato: () => `rgba(217, 51, 4, ${r})`,
  aqua: () => `rgba(0, 122, 134, ${r})`,
  petrol: () => `rgba(0, 81, 105,${r})`,
  sand: () => `rgba(169, 164, 135, ${r})`
})[g](), u = {
  playground: /* @__PURE__ */ e.createElement(n, null),
  violence: /* @__PURE__ */ e.createElement(o, null)
};
export {
  u as icons,
  m as toRgba
};
//# sourceMappingURL=index.es99.js.map
